function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Button, Space, Drawer, message, Tree, Tabs, Divider, notification, Modal, Table } from 'antd';
import { NodePlusFill, XSquareFill, Diagram3Fill, ClipboardFill, PencilFill, TrashFill, ExplicitFill } from 'react-bootstrap-icons';
import NewDepartment from "../components/forms/NewDepartment";
import NewService from "../components/forms/NewService";
import Common from "../components/includes/Common";
import AddSignaturePad from "../components/forms/AddSignaturePad";
import EditSignaturePad from "../components/forms/EditSignaturePad";
import Signature from "./Signature";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var confirm = Modal.confirm;
var Organisation = function Organisation() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isNewDeptFormVisible = _useState2[0],
    setIsNewDeptFormVisible = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isNewServiceFormVisible = _useState4[0],
    setIsNewServiceFormVisible = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isNewItemFormVisible = _useState6[0],
    setIsNewItemFormVisible = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    serviceTree = _useState8[0],
    setServiceTree = _useState8[1];
  var _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    spList = _useState0[0],
    setSpList = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    dataChanged = _useState10[0],
    setDataChanged = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isSpDataChanged = _useState12[0],
    setIsSpDataChanged = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isSpLoading = _useState14[0],
    setIsSpLoading = _useState14[1];
  var _useState15 = useState(null),
    _useState16 = _slicedToArray(_useState15, 2),
    selectedPad = _useState16[0],
    setSelectedPad = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    isEditPadVisible = _useState18[0],
    setIsEditPadVisible = _useState18[1];
  var spCols = [{
    title: /*#__PURE__*/_jsx("b", {
      children: "Nom"
    }),
    key: 'label',
    dataIndex: 'label',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Assistant(e)"
    }),
    key: 'owner',
    dataIndex: 'owner',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Manager"
    }),
    key: 'manager',
    dataIndex: 'manager',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Admin"
    }),
    key: 'admin',
    dataIndex: 'admin',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {}),
    key: 'action',
    dataIndex: 'action',
    render: function render(p) {
      return /*#__PURE__*/_jsxs(Space, {
        direction: "horizontal",
        children: [/*#__PURE__*/_jsx(Button, {
          type: "default",
          onClick: function onClick() {
            handlePadEdit(p);
          },
          children: /*#__PURE__*/_jsx(PencilFill, {
            size: 18
          })
        }), /*#__PURE__*/_jsx(Button, {
          type: "default",
          onClick: function onClick() {
            handlePadDelete(p);
          },
          children: /*#__PURE__*/_jsx(TrashFill, {
            size: 18
          })
        })]
      });
    }
  }];
  var handlePadEdit = function handlePadEdit(pad) {
    setSelectedPad(pad);
    setIsEditPadVisible(true);
  };
  var handlePadDelete = function handlePadDelete(pad) {
    setSelectedPad(pad);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["La suppression du classeur - ", pad.label]
      }),
      onOk: function onOk() {}
    });
  };
  var tabItems = [{
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(Diagram3Fill, {
        size: 22
      }), " STRUCTURE"]
    }),
    key: 1,
    children: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs(Space, {
        direction: "horizontal",
        children: [/*#__PURE__*/_jsx(Button, {
          type: "primary",
          style: {
            width: '98%'
          },
          icon: /*#__PURE__*/_jsx(NodePlusFill, {
            size: 26
          }),
          onClick: function onClick() {
            setIsNewDeptFormVisible(true);
          },
          children: /*#__PURE__*/_jsx("b", {
            children: "AJOUTER DEPTM"
          })
        }), /*#__PURE__*/_jsx(Button, {
          type: "primary",
          style: {
            width: '98%'
          },
          icon: /*#__PURE__*/_jsx(NodePlusFill, {
            size: 26
          }),
          onClick: function onClick() {
            setIsNewServiceFormVisible(true);
          },
          children: /*#__PURE__*/_jsx("b", {
            children: "AJOUTER UN SERVICE"
          })
        })]
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
        className: "white-bg cool-radius",
        children: /*#__PURE__*/_jsx(Tree, {
          showLine: true,
          showIcon: true,
          defaultExpandAll: true,
          autoExpandParent: true,
          defaultExpandParent: true,
          treeData: serviceTree
        })
      })]
    })
  }, {
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(ClipboardFill, {
        size: 22
      }), " OUTILS ASSISTANT"]
    }),
    key: 2,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(AddSignaturePad, {
        handler: function handler() {
          setIsSpDataChanged(true);
        }
      }), /*#__PURE__*/_jsx(Divider, {
        children: "Parafeur(s)"
      }), /*#__PURE__*/_jsx(Table, {
        dataSource: spList,
        columns: spCols,
        sticky: true,
        bordered: true,
        loading: isSpLoading,
        pagination: false
      })]
    })
  }, {
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(ExplicitFill, {
        size: 22
      }), " E-SIGNATURE"]
    }),
    key: 3,
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Signature, {})
    })
  }];
  useEffect(function () {
    axios.get(Common.baseApiUrl + 'getservicetree').then(function (response) {
      if (response.data.status == 200) {
        setServiceTree([]);
        response.data.services.forEach(function (d) {
          setServiceTree(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              title: d.label,
              key: 'd' + d.id.toString(),
              children: d.services.map(function (s) {
                return {
                  title: s.label,
                  key: "s" + s.id.toString()
                };
              })
            }]);
          });
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue ' + error.toString(),
        delay: 4
      });
    })["finally"](function () {});
  }, [dataChanged]);
  useEffect(function () {
    setIsSpDataChanged(false);
    setIsSpLoading(true);
    axios.get("".concat(Common.baseApiUrl, "getsignaturepads/").concat(Common.currentUser.id)).then(function (response) {
      if (response.data.status == 200) {
        setSpList([]);
        response.data.pads.forEach(function (p) {
          setSpList(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              key: p.id,
              label: p.label,
              owner: p.owner.prenom + " " + p.owner.nom,
              manager: p.manager.prenom + " " + p.manager.nom,
              admin: p.admin.prenom + " " + p.admin.nom,
              action: p
            }]);
          });
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue, verifier votre connexion internet',
        delay: 4
      });
    })["finally"](function () {
      setIsSpLoading(false);
    });
  }, [isSpDataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Tabs, {
      items: tabItems,
      animated: true,
      tabPosition: "left"
    }), /*#__PURE__*/_jsx(Drawer, {
      open: isNewDeptFormVisible,
      closeIcon: /*#__PURE__*/_jsx(XSquareFill, {
        size: 25
      }),
      width: 370,
      destroyOnClose: true,
      title: "Ajouter un d\xE9partement",
      onClose: function onClose() {
        setIsNewDeptFormVisible(false);
      },
      closable: true,
      children: /*#__PURE__*/_jsx(NewDepartment, {
        handler: function handler() {
          setDataChanged(true);
        }
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      open: isNewServiceFormVisible,
      closeIcon: /*#__PURE__*/_jsx(XSquareFill, {
        size: 25
      }),
      width: 370,
      destroyOnClose: true,
      title: "Ajouter un service",
      onClose: function onClose() {
        setIsNewServiceFormVisible(false);
      },
      closable: true,
      children: /*#__PURE__*/_jsx(NewService, {
        handler: function handler() {
          setDataChanged(true);
          setIsNewServiceFormVisible(false);
        }
      })
    }), selectedPad && /*#__PURE__*/_jsx(Drawer, {
      open: isEditPadVisible,
      closeIcon: /*#__PURE__*/_jsx(XSquareFill, {
        size: 25
      }),
      width: 370,
      destroyOnClose: true,
      title: "MODIFIER LE PARAFEUR",
      onClose: function onClose() {
        setIsEditPadVisible(false);
      },
      closable: true,
      children: /*#__PURE__*/_jsx(EditSignaturePad, {
        pad: selectedPad,
        handler: function handler() {
          setIsSpDataChanged(true);
          setIsEditPadVisible(false);
        }
      })
    })]
  });
};
export default Organisation;